var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.54 7.157a1.002 1.002 0 00-.959-.065L23.33 9.515c-.239.913-.635 1.829-1.122 2.721L28 9.562V24.36l-6.667 3.077v-13.75a27.965 27.965 0 01-2 2.631v11.119l-6.667-3.077v-7.687a30.253 30.253 0 01-2-2.541V24.36L4 27.437V11.712l4.554-1.576a8.007 8.007 0 01-.41-1.975l-5.47 1.893c-.404.14-.674.52-.674.946v18a1.003 1.003 0 001 1c.143 0 .286-.031.42-.092l8.246-3.807 8.248 3.807c.015.007.032.004.047.011.12.048.245.081.372.081.126 0 .251-.033.372-.081.015-.007.032-.004.047-.011l8.667-4c.354-.164.581-.519.581-.908V8c0-.341-.174-.658-.46-.843",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.847 9.758a2.02 2.02 0 11-.001-4.042 2.02 2.02 0 010 4.042m0-7.758a5.744 5.744 0 00-5.736 5.737c0 3.119 3.677 7.378 5.737 9.403 2.06-2.025 5.737-6.284 5.737-9.403A5.744 5.744 0 0015.847 2",
    fill: props.color
  })));
}

export default SvgIconMap;